import { useTranslation } from "react-i18next";
import {
  PageWrap,
  Section,
  Title,
  Subtitle,
  H2,
  H3,
  P,
  Ul,
  Ornament,
} from "./LegalStyles";

export default function CookiesPage() {
  const { t } = useTranslation();

  const bulletsNecessary = t("footer.legal.cookies.necessary.bullets", {
    returnObjects: true,
  });
  const bulletsAnalytics = t("footer.legal.cookies.analytics.bullets", {
    returnObjects: true,
  });
  const bulletsMarketing = t("footer.legal.cookies.marketing.bullets", {
    returnObjects: true,
  });

  return (
    <PageWrap>
      <Ornament />
      <Section>
        <Title>{t("footer.legal.cookies.title")}</Title>
        <Subtitle>{t("footer.legal.cookies.subtitle")}</Subtitle>
      </Section>

      <Section>
        <H2>{t("footer.legal.cookies.intro.h2")}</H2>
        <P>{t("footer.legal.cookies.intro.p1")}</P>
      </Section>

      <Ornament />

      <Section>
        <H2>{t("footer.legal.cookies.what.h2")}</H2>
        <P>{t("footer.legal.cookies.what.p1")}</P>
      </Section>

      <Section>
        <H2>{t("footer.legal.cookies.types.h2")}</H2>

        <H3>{t("footer.legal.cookies.necessary.h3")}</H3>
        <P>{t("footer.legal.cookies.necessary.p1")}</P>
        <Ul>
          {bulletsNecessary.map((li, i) => (
            <li key={i}>{li}</li>
          ))}
        </Ul>

        <H3>{t("footer.legal.cookies.analytics.h3")}</H3>
        <P>{t("footer.legal.cookies.analytics.p1")}</P>
        <Ul>
          {bulletsAnalytics.map((li, i) => (
            <li key={i}>{li}</li>
          ))}
        </Ul>

        <H3>{t("footer.legal.cookies.marketing.h3")}</H3>
        <P>{t("footer.legal.cookies.marketing.p1")}</P>
        <Ul>
          {bulletsMarketing.map((li, i) => (
            <li key={i}>{li}</li>
          ))}
        </Ul>
      </Section>

      <Section>
        <H2>{t("footer.legal.cookies.consent.h2")}</H2>
        <P>{t("footer.legal.cookies.consent.p1")}</P>
      </Section>

      <Section>
        <H2>{t("footer.legal.cookies.management.h2")}</H2>
        <P>{t("footer.legal.cookies.management.p1")}</P>
      </Section>

      <Section>
        <H2>{t("footer.legal.cookies.contact.h2")}</H2>
        <P>{t("footer.legal.cookies.contact.p1")}</P>
      </Section>

      <Ornament />
    </PageWrap>
  );
}
